import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiStatus } from 'common/enums';

import { CategoryDTO, EntityDetails, Source } from 'common/models/data/entity.model';
import initialEntityState from './entity.state';
import { EntityDetailsPayload } from 'common/models/data/entityStore.model';
import { IndicatorDTO, IndicatorVM } from 'common/models/data/indicator.model';
import { ApiInitiator } from 'common/enums/data.enum';

const entitySlice = createSlice({
    name: 'entity',
    initialState: initialEntityState,
    reducers: {
        fetchEntityDetails: (state, { payload }: PayloadAction<EntityDetailsPayload>) => {
            state.entityDetails.status = ApiStatus.LOADING;
        },
        fetchEntityDetailsSuccess: (state, { payload }: PayloadAction<EntityDetails>) => {
            state.entityDetails.status = ApiStatus.SUCCESS;
            state.entityDetails.data = payload;
        },
        fetchEntityDetailsError: (state, { payload }: PayloadAction<any>) => {
            state.entityDetails.status = ApiStatus.ERROR;
            state.entityDetails.error = payload;
        },
        fetchCategoryDetailsForEdit: (state, { payload }: PayloadAction<EntityDetailsPayload>) => {
            state.categoryDetails.status = ApiStatus.LOADING;
            state.categoryDetails.data = undefined;
        },
        fetchCategoryDetailsForEditSuccess: (state, { payload }: PayloadAction<CategoryDTO>) => {
            state.categoryDetails.status = ApiStatus.SUCCESS;
            state.categoryDetails.data = payload;
        },
        fetchCategoryDetailsForEditError: (state, { payload }: PayloadAction<any>) => {
            state.categoryDetails.error = payload;
            state.categoryDetails.status = ApiStatus.ERROR;
        },
        fetchIndicatorDetailsForEdit: (state, { payload }: PayloadAction<EntityDetailsPayload>) => {
            state.indicatorDetails.status = ApiStatus.LOADING;
            state.indicatorDetails.data = undefined;
        },
        fetchIndicatorDetailsForEditSuccess: (state, { payload }: PayloadAction<IndicatorVM>) => {
            state.indicatorDetails.status = ApiStatus.SUCCESS;
            state.indicatorDetails.data = payload;
        },
        fetchIndicatorDetailsForEditError: (state, { payload }: PayloadAction<any>) => {
            state.indicatorDetails.error = payload;
            state.indicatorDetails.status = ApiStatus.ERROR;
        },
        fetchSources: (state, { payload }: PayloadAction<ApiInitiator>) => {
            state.sources.status = ApiStatus.LOADING;
            state.sources.data = undefined;
        },
        fetchSourcesSuccess: (state, { payload }: PayloadAction<Array<Source>>) => {
            state.sources.status = ApiStatus.SUCCESS;
            state.sources.data = payload;
        },
        fetchSourcesFailed: (state, { payload }: PayloadAction<any>) => {
            state.sources.error = payload;
            state.sources.status = ApiStatus.ERROR;
        },
        resetIndicatorDetails: (state) => {
            state.indicatorDetails = {};
        },
        updateSourceList: (state, { payload }: PayloadAction<Source | undefined>) => {
            if (payload) state.sources.data = [...(state.sources.data || []), payload];
        },
        updateIndicatorDetails: (state, { payload }: PayloadAction<IndicatorDTO>) => {
            if (state.indicatorDetails.data) {
                state.indicatorDetails.data.details = payload;
            }
        }
    }
});

export default entitySlice.reducer;
export const entityActions = entitySlice.actions;
